import { gql } from '@apollo/client'

const ALL_REGIONS = gql`
  query RegionsQuery {
    regions_ALL {
      _id
      data {
        description
        areaId
        isWildcard
        id
      }
    }
  }
`

export { ALL_REGIONS }
